"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginKeyIcon = exports.FigureKey = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.FigureKey = styled_components_1.default.path `
    fill: ${({ theme }) => theme.colorTextRestButton};
`;
function LoginKeyIcon() {
    return (react_1.default.createElement("svg", { viewBox: "0 0 32 32", width: "32px", height: "32px" },
        react_1.default.createElement("path", { fill: "currentColor", d: "M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32Z" }),
        react_1.default.createElement(exports.FigureKey, { d: "M15,13,8,20v4h4V22h2V20h2l2.05-2.05,1.2-1.2Zm-5,9V20.586l5.293-5.293L16,16Z" }),
        react_1.default.createElement(exports.FigureKey, { d: "M19,8a4.994,4.994,0,0,0-4.168,7.754l.461-.461L16,16l-.536.536A5,5,0,1,0,19,8Zm2.121,7.121-4.242-4.242A3,3,0,0,1,21.2,15.047C21.171,15.072,21.146,15.1,21.121,15.121Z" })));
}
exports.LoginKeyIcon = LoginKeyIcon;
//# sourceMappingURL=LoginKeyIcon.js.map